import { Helmet } from 'react-helmet-async';

import { Content } from './components/Content';

export const AdminCloudLayoutsPage = () => {
  return (
    <>
      <Helmet>
        <title>Cloud Layouts - AutoScript Admin</title>
      </Helmet>
      <Content />
    </>
  );
};
